import React from 'react'
import { validateLunchTips } from '../actions'
import { useDispatch } from 'react-redux';

const ValidateLunchTipsButton = () => {
    const dispatch = useDispatch();
 return <button onClick={() => dispatch(validateLunchTips())}>Validate Lunch Tips</button>
 }

export default ValidateLunchTipsButton